import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "../redux/blockchain/blockchainActions";
import { fetchData } from "../redux/data/dataActions";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import logo from "../assets/images/dcrclogo.png";
import { HashLink } from "react-router-hash-link";


function NavBar() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const [walletAddress, setWallet] = useState("");
 
  // useEffect( () => { 
  //   async function getWallet() {
  //     dispatch(connect());
  //   if(blockchain.account !== null){
  //         setWallet(blockchain.account);
  //       }
  //   }
  //   getWallet();
  // }, []);

  // useEffect(() => {
  //   if(blockchain.account !== null){
  //         setWallet(blockchain.account);
  //   }
  // }, [blockchain.account]);

  

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar  justify-content-between"}
      // className={"navbar  justify-content-between"}
    >
       <Container>
        <Navbar.Brand href="/">
          <img src={logo} className="img-fluid logo" alt="brand" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
            style={{ justifyContent: "center"}}
        >

        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)}>Home</Nav.Link>
            </Nav.Item>
            {/* <Nav.Item>
              <Nav.Link as={Link} to="/faq" onClick={() => updateExpanded(false)}>
                 FAQ
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/roadmap" onClick={() => updateExpanded(false)}>
                 RoadMap
              </Nav.Link>
            </Nav.Item> */}
            {/* <Button  id="walletButton" className="wallet-button" 
              onClick={(e) => {
                e.preventDefault();
                dispatch(connect());
               getData();
              }}>
              {walletAddress.length > 0 ? (
                "Connected: " +
                String(walletAddress).substring(0, 6) +
                "..." +
                String(walletAddress).substring(38)
              ) : (
                <span>Connect Wallet</span>
              )}
            </Button> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>  );
}

export default NavBar;
